import Reveal from "./Reveal";
import { Container, Eyebrow } from "./Primitives";

const STEPS = [
  { title: "Tell us", body: "Describe what you want to improve in plain business language. No technical brief needed." },
  { title: "Assessment", body: "We diagnose the problem, clarify the outcome and scope the right approach with you." },
  { title: "We build", body: "Internal AI experts and trusted AI partners implement the solution, with managed quality review throughout." },
  { title: "Keep evolving", body: "As your organization changes, we refine, extend and add what comes next." },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="bg-panel pb-28 text-fg sm:pb-36">
      <Container className="border-t border-fg/10 pt-28 sm:pt-36">
        <Reveal className="flex flex-col items-center text-center">
          <Eyebrow className="text-tone">How It Works</Eyebrow>
          <h2 className="mt-6 max-w-2xl font-display text-4xl font-light leading-[1.02] tracking-[-0.04em] sm:text-5xl">
            From business problem to tailored working solution.
          </h2>
        </Reveal>
        <ol className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal as="li" key={s.title} delay={i * 100}
              className="border border-fg/15 bg-canvas p-7 transition-colors duration-300 hover:border-fg/35">
              <h3 className="font-display text-xl font-medium tracking-[-0.02em]">{s.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-subtle">{s.body}</p>
            </Reveal>
          ))}
        </ol>
      </Container>
    </section>
  );
}
